/**
 * 【KYMW1407】画像ファイルURL取得要求VO
 *
 * @export GetImageFileUrlModel
 * @class GetImageFileUrlModel
 */
export class GetImageFileUrlModel {
  // 画像プレビューファイルパス
  public imagePreviewPath: string = null;
  // 画像プレビューファイル名
  public imagePreviewName: string = null;
  // 画像ファイルパス
  public imageFilePath: string = null;
  // 画像ファイル名
  public imageFileName: string = null;
}
